import { render, staticRenderFns } from "./NavCollapsedButtons.vue?vue&type=template&id=46d8790e&scoped=true&"
import script from "./NavCollapsedButtons.vue?vue&type=script&lang=js&"
export * from "./NavCollapsedButtons.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "46d8790e",
  null
  
)

export default component.exports